/* eslint-disable fp/no-mutation */
import {createAction, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {ContentHotel} from '@findhotel/sapi'
import {HotelRequestType} from 'types/Hotel'

export interface HotelApiState {
  status: string
  data: Partial<ContentHotel> | null
}

export const initialState: HotelApiState = {
  status: '',
  data: {
    facilities: [],
    sentiments: [],
    imageURIs: []
  }
}

const {actions, reducer} = createSlice({
  name: 'hotelApi',
  initialState,
  reducers: {
    hotelFetchDone: (
      state: HotelApiState,
      action: PayloadAction<ContentHotel>
    ) => {
      state.data = action.payload
      state.status = action.type
    },
    hotelFetchClear: () => {
      return initialState
    },
    hotelFetchError: (state: HotelApiState, action) => {
      state.status = action.type
    },
    hotelFetchPending: (state: HotelApiState, action: PayloadAction) => {
      state.status = action.type
    }
  }
})

export const hotelFetch = createAction<HotelRequestType>(
  'hotelFetch/hotelFetch'
)

export const hotelFetchFatalError = createAction(
  'hotelFetch/hotelFetchFatalError'
)

export const {
  hotelFetchDone,
  hotelFetchClear,
  hotelFetchError,
  hotelFetchPending
} = actions

export type Actions =
  | typeof hotelFetch
  | typeof hotelFetchDone
  | typeof hotelFetchClear
  | typeof hotelFetchError
  | typeof hotelFetchPending
  | typeof hotelFetchFatalError

export default reducer
